module.exports = __webpack_public_path__ + "img/a2.3a737d8b.jpg";